import React, { useState } from "react";
import menuOptionIcon from "./../../images/menu.svg";
import { MoreOptions } from "./MoreOptions";
import { Colors } from "../../Constants/colors";

interface Props {
  onEdit?: () => unknown | undefined;
  onRemove?: () => unknown | undefined;
  isOpen?: boolean;
  onToggle?: () => void;
}

export const MoreOptionsMenu = ({
  onEdit,
  onRemove,
  isOpen,
  onToggle,
}: Props) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const iconRef = React.useRef<HTMLDivElement>(null);

  // Use controlled state if provided, otherwise fall back to internal state
  const [internalOpen, setInternalOpen] = useState<boolean>(false);
  const openOptionModal = isOpen !== undefined ? isOpen : internalOpen;
  const setOpenOptionModal = onToggle || setInternalOpen;

  return (
    <div
      ref={iconRef}
      onClick={(e) => {
        e.stopPropagation();
        if (onToggle) {
          onToggle();
        } else {
          setOpenOptionModal(true);
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: "relative",
        cursor: "pointer",
        padding: "6px",
        borderRadius: "6px",
        transition: "all 0.2s ease",
        backgroundColor: isHovered
          ? Colors.VeryLightGrey
          : openOptionModal
            ? Colors.WhiteSmoke
            : "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: isHovered ? "scale(1.05)" : "scale(1)",
      }}
    >
      <img
        src={menuOptionIcon}
        alt="menu-option-icon"
        style={{
          width: "20px",
          height: "20px",
          transition: "transform 0.2s ease",
          transform: openOptionModal ? "rotate(90deg)" : "rotate(0deg)",
        }}
      />

      <MoreOptions
        parentRef={iconRef}
        visible={openOptionModal}
        onClose={() => {
          if (onToggle) {
            onToggle();
          } else {
            setOpenOptionModal(false);
          }
        }}
        onEdit={onEdit}
        onRemove={onRemove}
      />
    </div>
  );
};
